/* Presentation only. Native menu, search, cart and product controllers stay in charge. */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('fate-immersive')) return;
  const header = document.querySelector('#header-component');
  const promo = document.querySelector('[id$="__fate_countdown_bar"]');
  const target = root.dataset.fateImmersivePage === 'index'
    ? document.querySelector('[id$="__ss_hero_33_68yKrd"]')
    : document.querySelector('.product-information__media');
  if (!header || !promo || !target) { root.classList.remove('fate-immersive'); return; }
  const categories = [...header.querySelectorAll('.fate-catbar,.header__navigation-bar-row')];
  let below = false;
  let observer;
  const update = () => {
    const open = !!document.querySelector('dialog[open],fate-navigation[data-open]');
    const focused = header.contains(document.activeElement);
    const solid = below || open || focused;
    root.classList.toggle('fate-header-solid', solid);
    categories.forEach(el => { el.inert = !solid; el.setAttribute('aria-hidden', String(!solid)); });
  };
  const measure = () => {
    const promoHeight = promo.getBoundingClientRect().height;
    root.style.setProperty('--fate-promo-height', `${promoHeight}px`);
    const boundary = promoHeight + Math.ceil(header.querySelector('.header__row--top').getBoundingClientRect().height);
    observer?.disconnect();
    observer = new IntersectionObserver(([entry]) => {
      below = entry.boundingClientRect.bottom <= boundary;
      update();
    }, {rootMargin:`-${boundary}px 0px 0px 0px`, threshold:0});
    observer.observe(target);
    below = target.getBoundingClientRect().bottom <= boundary;
    update();
  };
  const resize = new ResizeObserver(measure);
  resize.observe(promo);
  resize.observe(target);
  window.addEventListener('resize', measure, {passive:true});
  window.addEventListener('pageshow', measure);
  header.addEventListener('focusin', update);
  header.addEventListener('focusout', () => queueMicrotask(update));
  const dialogs = new MutationObserver(update);
  dialogs.observe(document.body, {subtree:true,attributes:true,attributeFilter:['open','data-open']});
  measure();
})();
